import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
interface Props {
  initInputValue: string[] | undefined;
  inputOnChange: (value: string[]) => void;
  choices?: Array<{
    label: string | Element;
    value: string;
    disable?: boolean;
  }>;
}
export function useCustomInput(inputProps) {
  const $ = _c(5);
  const {
    inputOnChange,
    initInputValue,
    choices
  } = inputProps;
  const [customInputValue, setCustomInputValue] = useState("");
  let t0;
  if ($[0] !== choices || $[1] !== customInputValue || $[2] !== initInputValue || $[3] !== inputOnChange) {
    const handleCustomInputChange = function handleCustomInputChange(value) {
      const inputValue = value;
      const oldCustomInputValue = customInputValue;
      const oldValue = initInputValue || [];
      const newValue = oldValue.filter(v => v !== oldCustomInputValue);
      inputOnChange([...newValue, inputValue]);
      const lastInput = choices?.[choices.length - 1];
      if (value.length > 0) {
        if (lastInput && !oldValue.includes(lastInput.value)) {
          if (initInputValue) {
            inputOnChange([...initInputValue, lastInput.value]);
          }
        }
      } else {
        inputOnChange(newValue.filter(v_0 => v_0 !== lastInput?.value));
      }
      setCustomInputValue(inputValue);
    };
    t0 = {
      handleCustomInputChange
    };
    $[0] = choices;
    $[1] = customInputValue;
    $[2] = initInputValue;
    $[3] = inputOnChange;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
}